
import type { IconProps } from 'src/types/icons';

const PausedNotesIcon = (props: IconProps) => (
  <svg {...props} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.728027" y="0.450195" width="24" height="24" rx="6" fill="#FF8E00" fillOpacity="0.1" />
    <path d="M9.95459 7.27148C9.62306 7.27146 9.30511 7.40315 9.07068 7.63757C8.83625 7.872 8.70457 8.18996 8.70459 8.52148V16.3789C8.70459 17.0693 9.26423 17.6289 9.95459 17.6289C10.6449 17.6289 11.2046 17.0693 11.2046 16.3789V8.52148C11.2046 8.18996 11.0729 7.872 10.8385 7.63757C10.6041 7.40315 10.2861 7.27146 9.95459 7.27148Z" fill="#FF8E00" />
    <path d="M15.8472 7.27148C15.5156 7.27146 15.1977 7.40315 14.9633 7.63757C14.7288 7.872 14.5971 8.18996 14.5972 8.52148V16.3789C14.5972 17.0693 15.1568 17.6289 15.8472 17.6289C16.5375 17.6289 17.0972 17.0693 17.0972 16.3789V8.52148C17.0972 8.18996 16.9655 7.872 16.7311 7.63757C16.4967 7.40315 16.1787 7.27146 15.8472 7.27148Z" fill="#FF8E00" />
  </svg>

);
export default PausedNotesIcon;
